import React, { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import __t from '../../lib/traduzioni';

/**
 * @type {import('@mui/material').ButtonProps}
 */
const buttonPropsDefault = {
    variant: 'contained', fullWidth: true, color: "primary"
}

/**
 * @type {import('@mui/material').SnackbarProps}
 */
const snackbarPropsDefault ={
    autoHideDuration: 6000
}

const DefaultSubmittingComp = () => <>
    <CircularProgress color="inherit" size={20} />
    {" "}
</>

/**
 * 
 * @returns 
 */
const DefaultErrorsDetailBtnComp = () => {

    return (
        <span title={__t("correggiperprocedere")}>
            <ErrorOutline />
        </span>
    )
}

/**
 * 
 * @param {{
 *  buttonProps: import('@mui/material').ButtonProps
 *  snackbarProps: import('@mui/material').SnackbarProps
 *  alertProps: import('@mui/lab').AlertProps
 * }} param0 
 * @returns 
 */
const BSSButton = ({    
    snackbarProps, 
    alertProps, 
    SubmittingComp = DefaultSubmittingComp, 
    ErrorsDetailBtnComp = DefaultErrorsDetailBtnComp,  
    children = __t("invio"),
    methods,
    ...buttonProps
}) => {

    const { formState } = methods;

    const [closed, setClosed] = useState(false);

    const {isSubmitted, errors, isSubmitSuccessful, isSubmitting, isValidating} = formState;

    const submissionState = isSubmitSuccessful ? "success" : "error";

    useEffect(() => {
        if(isSubmitting){
            setClosed(false)
        }
    }, [isSubmitting])


    const closeFn = () => setClosed(true)
    const defaultCloseProp = {onClose: closeFn}

    buttonProps = {...buttonPropsDefault, ...(buttonProps ?? {})};
    snackbarProps = {...snackbarPropsDefault, ...defaultCloseProp, ...(snackbarProps ?? {})};
    alertProps = {...defaultCloseProp, ...(alertProps ?? {})}

    return (
        <>            
            <Button disabled={isSubmitting || isValidating} {...buttonProps}>
                {(isSubmitting || isValidating) && (
                    <>
                        <SubmittingComp /> 
                    </>
                )}
                {isSubmitted && errors && Object.keys(errors).length > 0 && (
                    <>                        
                        <ErrorsDetailBtnComp errors={errors} /> 
                    </>
                )}
                {children}
            </Button> 
        </>
    )
    
}

export default BSSButton